import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "fullWidth", "color", "label", "bottomLabel", "error", "warning", "success", "maskProps", "focused", "labelProps", "fieldProps", "containerProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, Grid } from '@mui/material';
import { Icon } from '@elements/icon';
import { StyledFormControl, StyledFormHelperErrorText, StyledFormHelperSuccessText, StyledFormHelperText, StyledFormHelperWarningText, StyledInputLabel, StyledTextareaBase, StyleFormHelperWrapper } from './textarea-field.styles';
import Danger from '@images/danger.svg';
import Success from '@images/success.svg';
import Warning from '@images/warning.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var TextareaField = function TextareaField(_ref) {
  var name = _ref.name,
      fullWidth = _ref.fullWidth,
      color = _ref.color,
      label = _ref.label,
      bottomLabel = _ref.bottomLabel,
      error = _ref.error,
      warning = _ref.warning,
      success = _ref.success,
      maskProps = _ref.maskProps,
      focused = _ref.focused,
      labelProps = _ref.labelProps,
      fieldProps = _ref.fieldProps,
      containerProps = _ref.containerProps,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var inputName = name && "".concat(name, "-textareafield");
  var Component = StyledTextareaBase;
  var isError = !!error;
  var isWarning = !!warning;
  var isSuccess = !!success;
  var literalProps = {
    htmlFor: inputName,
    id: inputName,
    errorId: inputName && "".concat(inputName, "-error-text")
  };
  return /*#__PURE__*/_jsx(StyledFormControl, {
    error: isError,
    fullWidth: fullWidth,
    focused: focused,
    children: /*#__PURE__*/_jsxs(Grid, _objectSpread(_objectSpread({
      container: true,
      rowSpacing: 0.5,
      columnSpacing: 2,
      alignItems: "center"
    }, containerProps), {}, {
      children: [label && /*#__PURE__*/_jsx(Grid, _objectSpread(_objectSpread({
        item: true,
        xs: 12
      }, labelProps), {}, {
        children: /*#__PURE__*/_jsx(StyledInputLabel, {
          shrink: true,
          htmlFor: literalProps.htmlFor,
          children: label
        })
      })), /*#__PURE__*/_jsx(Grid, _objectSpread(_objectSpread({
        item: true,
        flex: "1 1"
      }, fieldProps), {}, {
        children: /*#__PURE__*/_jsxs(Box, {
          position: "relative",
          children: [/*#__PURE__*/_jsx(Component, _objectSpread({
            error: isError,
            id: literalProps.id,
            "aria-describedby": inputName,
            name: name,
            fullWidth: fullWidth,
            color: color
          }, restProps)), isError && /*#__PURE__*/_jsx(StyleFormHelperWrapper, {
            children: /*#__PURE__*/_jsxs(StyledFormHelperErrorText, {
              id: literalProps.errorId,
              children: [/*#__PURE__*/_jsx(Box, {
                display: "flex",
                pr: 0.75,
                children: /*#__PURE__*/_jsx(Icon, {
                  src: Danger,
                  width: 16,
                  height: 16
                })
              }), error]
            })
          }), isWarning && /*#__PURE__*/_jsx(StyleFormHelperWrapper, {
            children: /*#__PURE__*/_jsxs(StyledFormHelperWarningText, {
              id: literalProps.errorId,
              children: [/*#__PURE__*/_jsx(Box, {
                display: "flex",
                pr: 0.75,
                children: /*#__PURE__*/_jsx(Icon, {
                  src: Warning,
                  width: 16,
                  height: 16
                })
              }), warning]
            })
          }), isSuccess && /*#__PURE__*/_jsx(StyleFormHelperWrapper, {
            children: /*#__PURE__*/_jsxs(StyledFormHelperSuccessText, {
              id: literalProps.errorId,
              children: [/*#__PURE__*/_jsx(Box, {
                display: "flex",
                pr: 0.75,
                children: /*#__PURE__*/_jsx(Icon, {
                  src: Success,
                  width: 16,
                  height: 16
                })
              }), success]
            })
          }), bottomLabel && !isError && !isWarning && !isSuccess ? /*#__PURE__*/_jsx(StyleFormHelperWrapper, {
            children: /*#__PURE__*/_jsx(StyledFormHelperText, {
              children: bottomLabel
            })
          }) : null]
        })
      }))]
    }))
  });
};

export { TextareaField };